import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from './../../Global/Modals/Modal';
import Button from '@material-ui/core/Button';
import ButtonStyles from '../../../styles/button';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import CommentHeader from './CommentHeader';
import _get from 'lodash/get';
import CommentString from './CommentString';
import { formatComment } from './helpers';
import combineStyles from './../../../utils/combineStyles';
import TypographyStyles from '../../../styles/typography';
import classnames from 'classnames';

const styles = theme => ({
  commentContainer: { paddingTop: theme.spacing.unit * 2.5 }
});
export class SingleCommentModal extends PureComponent {
  static propTypes = {
    comment: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onEditClick: PropTypes.func.isRequired
  };

  render() {
    const {
      open,
      comment: { comment = {}, options = {} },
      onClose,
      classes,
      t,
      onEditClick
    } = this.props;
    const { changedUtc = '', createdByUser = {}, content = '' } = comment;
    const { users = [], editable = false, isAdmin = false, onDelete } = options;

    const parsedCommentText = formatComment(content);
    return (
      <Modal
        open={open}
        body={
          <Fragment>
            <CommentHeader
              inEditMode={false}
              firstName={_get(createdByUser, 'firstName', '')}
              lastName={_get(createdByUser, 'lastName', '')}
              changedUtc={changedUtc}
              onDelete={commentObject => {
                onClose();
                onDelete(commentObject);
              }}
              onEditClick={editCommentObject => {
                onClose();
                onEditClick(editCommentObject);
              }}
              comment={comment}
              users={users}
              editable={editable}
              deletable={isAdmin}
              isAdmin={isAdmin}
            />
            <div
              className={classnames(classes.commentContainer, classes.body2)}
            >
              {parsedCommentText.map((parsedText, index) => {
                return (
                  <CommentString
                    comment={parsedText}
                    key={index}
                    users={users}
                  />
                );
              })}
            </div>
          </Fragment>
        }
        footer={
          <Fragment>
            <Button
              className={classes.button}
              onClick={onClose}
              color={'primary'}
              classes={{ label: classes.buttonLabel }}
            >
              {t('Ok')}
            </Button>
          </Fragment>
        }
      />
    );
  }
}
const translatedSingleCommentModal = withNamespaces()(SingleCommentModal);
export default withStyles(
  combineStyles(ButtonStyles, TypographyStyles, styles)
)(translatedSingleCommentModal);
